
import React from "react";
import { Progress } from "@/components/ui/progress";

interface WorkflowProgressIndicatorProps {
  status: string;
  isPublished: boolean;
}

export default function WorkflowProgressIndicator({ 
  status, 
  isPublished 
}: WorkflowProgressIndicatorProps) {
  const getWorkflowStage = (status: string) => {
    const stages = ['pending', 'approved', 'published'];
    return stages.indexOf(status) + 1;
  };

  const getProgressPercentage = (status: string) => {
    if (status === 'rejected') return 25; // Show some progress but indicate rejection
    if (isPublished) return 100; // Published
    const stage = getWorkflowStage(status);
    return (stage / 3) * 100;
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span>Application Progress</span>
        <span>
          {status === 'rejected' ? 'Rejected' : 
           isPublished ? '3/3 (Published)' : 
           `${getWorkflowStage(status)}/3`}
        </span>
      </div>
      <Progress 
        value={getProgressPercentage(status)} 
        className={`h-2 ${status === 'rejected' ? 'bg-red-100' : ''}`}
      />
      
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>Submitted</span>
        <span>Approved</span>
        <span>Published</span>
      </div>
    </div>
  );
}
